<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import dealContent from 'dashboard/components-next/Deals/EmptyState/dealEmptyStateContent';

defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
  showButton: {
    type: Boolean,
    default: true,
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['create']);

const onClick = () => emit('create');
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-2 p-px overflow-hidden">
        <div
          v-for="deal in dealContent.slice(0, 5)"
          :key="deal.id"
          class="flex items-center justify-between p-4 rounded-xl border border-n-weak bg-n-alpha-1"
        >
          <div class="flex flex-col gap-1">
            <span class="text-sm font-medium text-n-slate-12">{{
              deal.name
            }}</span>
            <span class="text-xs text-n-slate-10">
              {{ deal.currency }} {{ deal.value }}
            </span>
            <div v-if="deal.labels?.length" class="flex flex-wrap gap-1 mt-1">
              <span
                v-for="label in deal.labels"
                :key="label.title"
                class="flex items-center gap-1 px-1.5 py-0.5 text-[10px] rounded-full border border-n-weak text-n-slate-11"
              >
                <span
                  class="size-1.5 rounded-full shrink-0"
                  :style="{ backgroundColor: label.color }"
                />
                {{ label.title }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #actions>
      <div v-if="showButton">
        <Button :label="buttonLabel" icon="i-lucide-plus" @click="onClick" />
      </div>
    </template>
  </EmptyStateLayout>
</template>
